import { useReportContext } from "@/components/Evaluate/report-context";
import { SourceType } from "@/components/PowerBlock/Block/SourcesField/SelectSource";
import { ReportColumn, ColumnType } from "@/types/evaluate";

const useAllSources = (columns: ReportColumn[]) => {
  const { selectedColumn } = useReportContext();

  const filteredColumns = columns.filter(
    column => column.id !== selectedColumn?.id && column.id && column.id !== -999,
  );

  return {
    [SourceType.Dataset]: filteredColumns
      .filter(column => column.column_type === ColumnType.DATASET)
      .map(({ name }) => name),
    [SourceType.InputVariable]: [],
    [SourceType.Dependency]: filteredColumns
      .filter(column => column.column_type !== ColumnType.DATASET)
      .map(({ name }) => name),
    [SourceType.Column]: [],
  };
};

export default useAllSources;
